module.exports = __webpack_public_path__ + "resource/img/no-ava.02e71abd.svg";